<div class="interactive-overlay">
  @if (icon()) {
    <mdw-icon [icon]="icon()!" [ngClass]="classes()"></mdw-icon>
  }
  <div class="text-content" [class.fill-width]="fillTextContent()" #textContent>
    <ng-content></ng-content>
  </div>
  <mdw-swap-animate
    class="notification-container"
    [model]="{ badge: badge(), passiveBadge: passiveBadge(), badgeColor: badgeColor() }"
  >
    <ng-template mdwSwap let-model>
      @if (model.badge) {
        <div class="mdw-notification-badge" [class.warning]="model.badgeColor === 'Warning'">
          {{ model.badge }}
        </div>
      } @else if (model.passiveBadge) {
        <div class="mdw-notification-passive-badge"></div>
      }
    </ng-template>
  </mdw-swap-animate>

  @if (showDownArrow()) {
    <mdw-icon [icon]="icons.DropdownArrow" [ngClass]="classes()"></mdw-icon>
  }
</div>
